(function() {
    'use strict';
    /*
     * Copyright (c) 2015-2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('ihh.common-web.ViewEditSelectCtrl', ViewEditSelectCtrl);

    ViewEditSelectCtrl.$inject = ['$scope'];

    function ViewEditSelectCtrl ($scope) {
        $scope.getValueString = function(value) {
            return $scope.formatValue ? $scope.formatValue(value) : value;
        };

        $scope.closeDropdown = function($event) {
            $event.target.parentElement.parentElement.parentElement.click();
        };
    }
})();